<template>
  <div class="table-wrapper">
    <b-table-new
      class="generalTableClass mb-2"
      :class="[pendingIncomesFromSale.length > 0 ? 'width93' : '']"
      :items="pendingIncomesFromSale"
      :fields="filteredColumns"
      hover="hover"
      striped="striped"
      bordered="bordered"
      :current-page="payloadForPendingFromSale.page"
      :per-page="0"
      responsive
      show-empty
    >
      <template slot="empty">
        <h4>{{$t('empty')}}</h4>
      </template>

      <template v-slot:cell(id)="data">
        <strong>{{paginate(data.index, payloadForPendingFromSale.page, payloadForPendingFromSale.limit)}}</strong>
      </template>

      <template v-slot:cell(regNumber)="data">{{ data.item.saleNumber }}</template>
	  <!-- HERE WE SHOW AMOUNT_OF_AFTER_PROMO_UZS -->
      <template v-slot:cell(amountOfPaymentUzs)="data">
        {{ calculateTotalPriceAndPriceAfterForDoc(data.item, true) | currency({
        symbol:
        userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
        }) }}
      </template>

      <!-- <template v-slot:cell(amountOfAfterPromoUzs)="data">
        <strong>
          {{ calculateTotalPriceAndPriceAfterForDoc(data.item, true) | currency({
          symbol:
          userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
          }) }}
        </strong>
      </template> -->
      <template v-slot:cell(regDate)="data">{{ data.item.reg_date }}</template>
      <template v-slot:cell(totalCount)="data">{{ calculateTotalCountOfItems(data.item) }}</template>
      <template v-slot:cell(senderName)="data">{{ data.item.senderName }}</template>
      <template
        v-slot:cell(senderDepartment)="data"
      >{{ data.item.departmentName }} ({{ data.item.departmentAddress }})</template>
      <template v-slot:cell(actions)="data">
        <div>
          <b-link @click="checkDocIdAndRedirect(data.item)">
            <i class="fa fa-edit"></i>
          </b-link>
        </div>
      </template>
    </b-table-new>
    <nav>
      <b-pagination
        :total-rows="totalPendingFromSale"
        :per-page="payloadForPendingFromSale.limit"
        v-model="payloadForPendingFromSale.page"
        :prev-text="$t('pagination.prev')"
        :next-text="$t('pagination.next')"
        hide-goto-end-buttons
      />
    </nav>
    <div v-if="incomeFromSaleLoader" class="spinner-wrapper">
      <b-spinner variant="primary"></b-spinner>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { BTable } from 'bootstrapVue2';


export default {
  name: 'IncomesFromSale',
  /**
   * COMPONENTS
   */
  components: {
	'b-table-new': BTable
  },
  /**
   * DATA
   */
  data() {
    return {
      filteredColumns: [],
      payloadForPendingFromSale: {
        page: 1,
        limit: 20
      }
    };
  },

  /**
   * COMPUTED
   */
  computed: {
    ...mapState(['userDepCurrencyName']),
    ...mapState('whIncomeModule', [
      'pendingIncomesFromSaleFields',
      'incomeFromSaleLoader',
      'totalPendingFromSale',
      'pendingIncomesFromSale'
    ])
  },

  /**
   * METHODS
   */
  methods: {
    /**
     * TOTAL PRICE AND PRICEAFTER FOR PENDING DOC
     * RECEIVES document AND forAfterPromo (boolean)
     * RETURNS TOTALPRICE OR TOTALPRICEAFTERPROMO
     */
    calculateTotalPriceAndPriceAfterForDoc(doc, forAfterPromo) {
      let totalPrice = 0;
      let count = 0;
      if (Array.isArray(doc.saleItems)) {
        let length = doc.saleItems.length;
        if (this.hasWrapped(doc.saleItems, length)) {
          for (let i = 0; i < length; i++) {
            if (doc.saleItems[i].wrapped) {
              count =
                parseFloat(doc.saleItems[i].count) -
                (doc.saleItems[i].receiveCount
                  ? parseFloat(doc.saleItems[i].receiveCount)
                  : 0);
              totalPrice +=
                count *
                (forAfterPromo
                  ? doc.saleItems[i].priceAfterUzs
                  : doc.saleItems[i].priceWholesale);
            }
          }
        } else {
          for (let i = 0; i < length; i++) {
            count =
              parseFloat(doc.saleItems[i].count) -
              (doc.saleItems[i].receiveCount
                ? parseFloat(doc.saleItems[i].receiveCount)
                : 0);
            totalPrice +=
              count *
              (forAfterPromo
                ? doc.saleItems[i].priceAfterUzs
                : doc.saleItems[i].priceWholesale);
          }
        }
      }
      return totalPrice;
    },
    hasWrapped(itemsArray, length) {
      let boolean = false;
      for (let i = 0; i < length; i++) {
        if (itemsArray[i].wrapped) {
          boolean = true;
          break;
        }
      }
      return boolean;
    },
    calculateTotalCountOfItems(doc) {
	  let tempTotal = 0;
	  if (!Array.isArray(doc.saleItems)) {
		  doc.saleItems = JSON.parse(doc.saleItems);
	  }
      if (Array.isArray(doc.saleItems)) {
        let length = doc.saleItems.length;
        if (this.hasWrapped(doc.saleItems, length)) {
          for (let i = 0; i < length; i++) {
            if (doc.saleItems[i].wrapped) {
              tempTotal +=
                parseFloat(doc.saleItems[i].count) -
                (doc.saleItems[i].receiveCount
                  ? parseFloat(doc.saleItems[i].receiveCount)
                  : 0);
            }
          }
        } else {
          for (let i = 0; i < length; i++) {
            tempTotal +=
              parseFloat(doc.saleItems[i].count) -
              (doc.saleItems[i].receiveCount
                ? parseFloat(doc.saleItems[i].receiveCount)
                : 0);
          }
        }
      }
      return tempTotal;
    },
    async checkDocIdAndRedirect(currentPendingIncome) {

      this.$store.commit(
        'whIncomeModule/setCurrentIncomeFromSale',
        currentPendingIncome
      );
      this.$router.push(
        `/warehouse-management/pendingIncome/fromSale/edit/${currentPendingIncome.id}`
      );
    },
    paginate(index, page_size, page_number) {
      --page_size;
      return page_number * page_size + index + 1;
    },
    fetchPendingIncomesFromSaleFn() {
      this.fetchPendingIncomesFromSale(this.payloadForPendingFromSale);
    },
    ...mapActions('whIncomeModule', ['fetchPendingIncomesFromSale']),

    setColumns() {
      this.filteredColumns = this.filterColumns(
        this.pendingIncomesFromSaleFields
      );
    },

    /**
     * Filter columns
     * @param columns
     * @returns {*[]}
     */
    filterColumns(columns = []) {
      return columns.filter(column => {
        if (column.visible) {
          column.label = this.$t(column.label);
          return column;
        }
      });
    },

    /**
     * Column listener
     * @param $event
     */
    columnListener($event) {
      setTimeout(() => {
        this.filteredColumns = this.filterColumns($event);
      }, 200);
    }
  },

  /**
   * CREATED HOOK
   */
  created() {
    // this.fetchPendingIncomesFromSale(this.payloadForPendingFromSale);
    this.$eventHub.$on('columnListener', this.columnListener);
    this.$eventHub.$on('setColumnsFromSale', this.setColumns);
    this.$eventHub.$on(
      'fetchPendingIncomesFromSale',
      this.fetchPendingIncomesFromSaleFn
    );
  },

  /**
   * MOUNTED HOOK
   */
  mounted() {
    this.setColumns();
  },

  /**
   * BEFOREDESTROY HOOK
   */
  beforeDestroy() {
    this.$eventHub.$off('setColumnsFromSale');
    this.$eventHub.$off('fetchPendingIncomesFromSale');
  }
};
</script>

<style lang="scss" scoped>
.table-wrapper /deep/ {
	@import '~bootstrapVue2/dist/bootstrap-vue.min';
}

.no-wrap {
  white-space: nowrap;
}

.table-wrapper {
  position: relative;
  padding: 5px;
}

.spinner-wrapper {
  position: absolute;
  background: rgba(32, 28, 32, 0.49);
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  padding-top: 35px;
  z-index: 5;
}
</style>
